// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_4-3";
export var dialog = "_4-0";
export var divClassnameSwatch = "_4-8";
export var flexSwatch = "_4-4";
export var header = "_4-1";
export var styleAttributeSwatch = "_4-7";
export var swatch = "_4-2";
export var textHeaderSwatch = "_4-5";
export var webSwatch = "_4-6";